/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import { cloneDeep } from 'lodash';

import {
    FETCH_SCHOOL_DETAILS_SUCCESS,
    CLEAR_SCHOOL_DETAIL,
    FETCH_CONTACT_DETAILS_SUCCESS,
    FETCH_SALES_FOCE_DETAILS_SUCCESS,
    FETCH_CREATOR_DETAILS_SUCCESS,
    SEARCH_SCHOOL_BY_POSTALCODE_SUCCESS,
    RESET_SCHOOL_LIST,
    SET_ORG_UNIT,
    SET_COURSE_NO,
    SET_COURSE_NAME,
    SET_ESTIMATED_ENROLLMENTS,
    SET_CLASS_START,
    SET_END_START} from '../_actions/order.details.actions';

export const INITIAL_STATE= {
    creator : {},
    contact:{},
    salesForceOrgEntities: [],
    school:{},
    searchedSchools: []
};

export function orderDetailReducer ( state = INITIAL_STATE, action){
    switch (action.type){
        case FETCH_SCHOOL_DETAILS_SUCCESS: {
            return { ...state, school: action.payload};
        }
        case CLEAR_SCHOOL_DETAIL: {
            return { ...state, school: {}};
        }
        case FETCH_CONTACT_DETAILS_SUCCESS: {
            return { ...state, contact: action.payload};
        }
        case FETCH_SALES_FOCE_DETAILS_SUCCESS: {
            return { ...state, salesForceOrgEntities: action.payload};
        }
        case FETCH_CREATOR_DETAILS_SUCCESS: {
            return { ...state, creator: action.payload};
        }
        case SEARCH_SCHOOL_BY_POSTALCODE_SUCCESS: {
            return {...state, searchedSchools: action.payload};
        }
        case RESET_SCHOOL_LIST: {
            return {...state, searchedSchools: INITIAL_STATE.searchedSchools};
        }
        case SET_ORG_UNIT :{
            const schoolInfo = cloneDeep(state.school);
            schoolInfo.salesForceOrg = action.payload;
            return { ...state, school: schoolInfo};
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/order.details.reducer.js